import React from 'react';

import {
  Box,
  Divider,
  Grid,
  Skeleton,
  Typography,
  useMediaQuery,
  useTheme,
} from '@mui/material';

interface CondosPreloaderProps {
  amount: number;
}

const CondosPreloader = ({ amount }: CondosPreloaderProps) => {
  const theme = useTheme();
  const lessLg = useMediaQuery(theme.breakpoints.down('lg'));
  return (
    <Grid container spacing={3}>
      {new Array(amount).fill(null).map((_, i) => (
        <Grid key={i} item sm={12} md={6} lg={4}>
          <Skeleton
            animation="wave"
            variant="rectangular"
            width="100%"
            height={lessLg ? 160 : 288}
          />
          <Box>
            <Typography variant="h3">
              <Skeleton width={200} />
            </Typography>
            <Typography variant="h2">
              <Skeleton width={250} />
            </Typography>
            <Typography variant="caption">
              <Skeleton width={180} />
            </Typography>
            <Typography variant="caption">
              <Skeleton width={300} />
            </Typography>
            <Divider />
            <Typography variant="h5" marginRight={1}>
              <Skeleton width={280} />
            </Typography>
            <Typography variant="h5">
              <Skeleton width={280} />
            </Typography>
          </Box>
        </Grid>
      ))}
    </Grid>
  );
};

export default CondosPreloader;
